import { CgSoftwareDownload } from 'react-icons/cg';
import { StyledButton } from '@app/components/button/Button';
import type { TokenUsageRow } from '@app/services/api.types';
import { buildTokenUsageCsv } from '../utils/csv';

type ExportBtnProps = {
    rows: TokenUsageRow[];
    fileName?: string;
};

const handleExport = (rows: TokenUsageRow[], fileName: string) => {
    const csvContent = buildTokenUsageCsv(rows);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
};

const ExportBtn = ({ rows, fileName = 'token-usage.csv' }: ExportBtnProps) => {
    return (
        <StyledButton
            type="primary"
            icon={<CgSoftwareDownload size={20} />}
            onClick={() => handleExport(rows, fileName)}
            disabled={!rows.length}>
            Export CSV
        </StyledButton>
    );
};

export default ExportBtn;
